import { canNavigate, ConductorOneChildActive, Router, ScreenBase, splitUrlSegments } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import OmissionViewModel, { OmissionNoticeNavigationName } from "./omissionViewModel";
import { Notice } from "../../../services/NIA/niaService";
import NoticeEntity from "../../../models/notice";
import OmissionDocumentsUploadedViewModel, {
  OmissionDocumentsUploadedViewModelNavigationName,
} from "./omissionDocumentsUploadedViewModel";

export const OmissionModuleNavigationName = "omission";

@Router.registerRoute({
  route: OmissionModuleNavigationName,
  name: Router.Self,
  children: [OmissionViewModel, OmissionDocumentsUploadedViewModel],
})
export default class OmissionNoticeViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private documentsVMFactory: ReturnType<typeof OmissionDocumentsUploadedViewModel.Factory>,
    public localizationService: LocalizationService,
    private omissionViewModel: OmissionViewModel
  ) {
    super();
    this.nameValue = "omission.title";
    this.navigationName = OmissionModuleNavigationName;
    this.children.push(this.omissionViewModel);
  }

  onInitialize() {
    return this.tryActivateChild(this.omissionViewModel);
  }

  async navigate(subPath: string | undefined, params: any) {
    const segments = splitUrlSegments(subPath);
    let childToActivate;
    if (segments[0] === OmissionDocumentsUploadedViewModelNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    } else if (segments[0] === OmissionNoticeNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    }

    if (childToActivate) {
      await this.tryActivateChild(childToActivate);

      if (canNavigate(childToActivate)) {
        await childToActivate.navigate(segments[1], params);
      }
    }

    await this.onChildNavigated(childToActivate);
  }

  async findNavigationChild(navigationName: string) {
    if (navigationName.includes(OmissionDocumentsUploadedViewModelNavigationName)) {
      const noticeString = sessionStorage.getItem(Notice.OMISSION);

      if (noticeString) {
        const notice = JSON.parse(noticeString) as NoticeEntity;

        if (notice._noticeBase64) {
          return this.documentsVMFactory(notice._noticeBase64, Notice.OMISSION);
        }
      }
    }
    return super.findNavigationChild(navigationName);
  }
}
